//import my-pik form "./components/Animation/pik-my.png"
//I Would Highly Recommend You To Customize The Theme According To Your Taste.
//import imgpic from "./components/Animation/pik-my.png"
export const globalStyles = {
  "--grad": "linear-gradient(315deg,#0e8cfb,#53fc96)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #48a9fe 0%, #734ae8 74%)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #06bcfb 0%, #4884ee 74%)",
  "--txtcolor": "#272341",
  "--p_color": "#31aefb",
  "--t_color":"#05d2a2d0",
  "--f_color": "#0ac76f",
  "--s_color": "#fff",
};

// Navigation Bar Name
export const navbar_name = "<Mayukh>";

// Main Page
export const main = {
  name: "Mayukh Sen",
  doamin: "A MERN Stack Web Developer",
  resume:
    "https://drive.google.com/file/d/18mQBx1cDkwhRpV6ZN67OhOU9JMeKc2-E/view?usp=share_link",
};

// AboutMe
export const aboutme = {
  
 imgLink: "https://avatars.githubusercontent.com/u/108891171?v=4",
  p1: "Hey, My name is Mayukh Sen. I have completed my Bachelor of Engineering from Government college of engineering and textile technology, Berhampore.",
  p2: " I'm a passionate coder and an enthusiastic Web Developer capable of applying programming skills to solve complex problems. Seeking a challenging role in the field of software development that will offer an opportunity for further development of my abilities, skills and knowledge in an organization.",
  p3: "Apart from coding I also like travelling and gaming. And I like to explore historical places with vlogging.",
};

// Skills 
export const whatido = {
  title: "Full Stack Web Development",

  details: [
    "Building responsive website using HTML,CSS,JS,React",
    "Creating backend application in Node, ExpressJS",
    "Building Simple RESTful CRUD APIs",
    "Knowledge of MongoDB Database",
    "Knowledge of various UI libraries like ChakraUI",
  ],
  logos: [
    {
      name: "HTML5",
      iconifyClassName: "vscode-icons:file-type-html", // PS : Use iconify class name
      id: "1",
    },
    {
      name: "CSS",
      iconifyClassName: "vscode-icons:file-type-css",
      id: "2",
    },
    {
      name: "JavaScript",
      iconifyClassName: "logos:javascript",
      id: "3",
    },
    {
      name: "ReactJS",
      iconifyClassName: "vscode-icons:file-type-reactjs",
      id: "4",
    },
    {
      name: "Redux",
      iconifyClassName: "logos:redux",
      id: "5",
    },
    {
      name: "NodeJS",
      iconifyClassName: "logos:nodejs",
      id: "6",
    },
    {
      name: "ExpressJS",
      iconifyClassName: "logos:express",
      id: "7",
    },
    {
      name: "MongoDB",
      iconifyClassName: "logos:mongodb",
      id: "8",
    },
    {
      name: "Postman",
      iconifyClassName: "logos:postman-icon",
      id: "9",
    },
    {
      name: "npm",
      iconifyClassName: "logos:npm-icon",
      id: "10",
    },
    {
      name: "GIT",
      iconifyClassName: "logos:git",
      id: "11",
    },
    {
      name: "Material-UI",
      iconifyClassName: "logos:material-ui",
      id: "13",
    },
    {
      name: "Ant Design",
      iconifyClassName: "logos:ant-design",
      id: "14",
    },
    {
      name: "Netlify",
      iconifyClassName: "vscode-icons:file-type-netlify",
      id: "15",
    },
  ],
};

// Project Details
export const details = [
  {
    id: 1,
    title: "Calendly-Website-clone",
    desc: `In this project we have tried to make a look alike clone of Calendly.com. With our efforts and the technology stack, that we have learned till now in Unit-4 in Masai School, we were able to clone the front end, integrated it with backend and added similar looks and features.`,
    feature: `Sign-in/Sign-up,
              backend database is use to show product and add to cart, book the date and time.`,
    tech: `Tech Stack: HTML | CSS | JavaScript `,
    img: "https://savvycal.ongloat.com/content/images/2022/06/guide-to-calendly-3.png",
    link: "https://funny-gecko-ec24e9.netlify.app/",
    github: "https://github.com/senCoder12/Masai-Calendly-project",
    
  },
  {
    id: 2,
    title: "fatsecret.com Clone",
    desc: `This is a clone of fitness tracking website. that's provide to maintain the food's amount and you can also post comment in the feed page.`,
    feature: `Sign-in/Sign-up,
              Feed page,
              Food page,
              search food accordingly.`,
    tech: `Tech Stack: HTML | CSS | JavaScript | json server`,
    img: "https://cdn.hashnode.com/res/hashnode/image/upload/v1662830770166/VlGJE1Pi0.jpg?auto=compress,format&format=webp",
    github: "https://github.com/senCoder12/masai-fatsecret-project",
    link: "https://gentle-kashata-e21372.netlify.app/"
  },
  
  {
    id: 6,
    title: "Overstock.com",
    desc: `Overstock.com Inc. is an online retailer and technology company. The Company is an e-commerce retailer offering customers a range of brands for the home at low prices, including furniture, home decor, area rugs, bedding and bath, home improvement, outdoor, and kitchen and dining items, among others.`,
    feature: `SignUp/Login,
              Landing page with responsiveness
              Products Page sorting and filtering Functionality together,
              Cart Page,
              Payment Page
              `,
    tech: `Tech Stack: React Js | CSS | Redux | Heroku`,
    img: "https://user-images.githubusercontent.com/96625397/200256356-e72a1993-8d54-4b4b-9984-2d1ffcc2a7d6.png",
    link: "https://overstock-clone-akash.netlify.app/",
    github: "https://github.com/web-dev-akash/Team_OverStock",
  },
  {
    id: 7,
    title: "Touropedian",
    desc: `Tour blog website`,
    feature: `SignUp/Login,
              Every page with responsiveness
              Search functionality with filter by tag,
              Single page,
              Dashboard,
              Edit-Delete functionality 
              `,
    tech: `Tech Stack: React Js | Redux | CSS | Node Js | Express Js | MongoDB | MDBootstrap`,
    img: '/touropedian.png',
    link: "https://touropedian.netlify.app/",
    github: "https://github.com/senCoder12/Blog-application",
  },
  {
    id: 8,
    title: "Flipkart",
    desc: `Tour blog website`,
    feature: `A user can Sign in or Sign up, category-wise
    page listing, product filtration, add to cart,
    and Multiple payment options
              `,
    tech: `Tech Stack: React Js | Redux | Node Js | Express Js | MongoDB | MDBootstrap`,
    img: 'https://allusefulinfo.com/wp-content/uploads/2013/11/flipkart-website.jpg',
    link: "https://flipkartclone04.netlify.app/",
    github: "https://github.com/mr-ramzan01/filpkart-clone-backend",
  }
];

// Social Media Links
export const links = [
  
  "https://www.linkedin.com/in/mayukh-sen12/",
  "https://api.whatsapp.com/send/?phone=8116089383&text&app_absent=0",
  "https://github.com/senCoder12",
];
